/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Share_Empty_PlanInputs */

const en_us2_plan_share_empty_plan = /** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an exercise to the plan before sharing it.`)
};

const pt_br2_plan_share_empty_plan = /** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um exercício ao plano antes de compartilhar.`)
};

const pt_pt2_plan_share_empty_plan = /** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um exercício ao plano antes de compartilhar.`)
};

/** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */
const es_419_plan_share_empty_plan = en_us2_plan_share_empty_plan;

/** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */
const fr_fr2_plan_share_empty_plan = en_us2_plan_share_empty_plan;

/** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */
const de_de2_plan_share_empty_plan = en_us2_plan_share_empty_plan;

/** @type {(inputs: Plan_Share_Empty_PlanInputs) => LocalizedString} */
const it_it2_plan_share_empty_plan = en_us2_plan_share_empty_plan;

/**
* | output |
* | --- |
* | "Add an exercise to the plan before sharing it." |
*
* @param {Plan_Share_Empty_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_share_empty_plan = /** @type {((inputs?: Plan_Share_Empty_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Share_Empty_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_share_empty_plan(inputs)
	if (locale === "es-419") return es_419_plan_share_empty_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_share_empty_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_share_empty_plan(inputs)
	if (locale === "de-DE") return de_de2_plan_share_empty_plan(inputs)
	if (locale === "it-IT") return it_it2_plan_share_empty_plan(inputs)
	return en_us2_plan_share_empty_plan(inputs)
});
export { plan_share_empty_plan as "plan_share.empty_plan" }